@if (definition && form) {
  <div
    class="flex flex-col"
    >
    <label class="soft-label top"
      >{{ definition?.title }}
      @if (definition?.required | booleanRule: form.value) {
        <span
          class="required-indicator"
          >*</span
          >
        }
      </label>
      @switch (definition.control) {
        @case ('dropdown') {
          <soft-select [formControl]="form|formControl:definition.name"
            softFieldValidation>
            @for (option of definition.options; track option) {
              <soft-select-option
                [value]="option.value"
                [disabled]="definition.readonly | booleanRule: form.value"
                >{{ option.title }}
              </soft-select-option>
            }
          </soft-select>
        }
        @default {
          <soft-radio-group
            [formControl]="form|formControl:definition.name"
            class="flex flex-row"
            softFieldValidation
            >
            @for (option of definition.options; track option; let i = $index) {
              <div
                class="flex flex-row"
                >
                <soft-radio-option
                  [value]="option.value"
                  [disabled]="definition.readonly | booleanRule: form.value"
                  >
                  <span class="soft-label soft-label-right">{{ option.title }}</span>
                </soft-radio-option>
              </div>
            }
          </soft-radio-group>
        }
      }
    </div>
  }
